import React, { useState } from "react";
import "./Header.css";
import { Link, NavLink, useLocation } from "react-router-dom";
import MainHeader from "./MainHeader";
import JobHeader from "./JobHeader";
import RecruiterHeader from "./RecruiterHeader";
import { useEffect } from "react";
import SabKaBaap from "./SabKaBaap";

const Header = () => {
  const location = useLocation();
  const [headerText, setHeaderText] = useState(location.pathname);

  useEffect(() => {
    setHeaderText(location.pathname);
  }, []);

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const logoStyle = {
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
  };

  return (
    <>
      <SabKaBaap />     
    </>
  );
};

export default Header;
